import {combineEpics} from 'redux-observable';
import userEventEpic from './userEventEpic';
import eventsCategoriesEpic from './eventsCategoriesEpic';
import eventSourcesEpic from './eventsSourcesEpic';

export default combineEpics(userEventEpic, eventsCategoriesEpic, eventSourcesEpic);
